import { render, staticRenderFns } from "./esqueci-senha-sucesso.vue?vue&type=template&id=6bc204e4&"
import script from "./esqueci-senha-sucesso.vue?vue&type=script&lang=js&"
export * from "./esqueci-senha-sucesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports